module.exports = __webpack_public_path__ + "img/pro-5-gen-landscape.ba0d72d.png";